// extracted by mini-css-extract-plugin
module.exports = {"load-shedding-O":"O_load-shedding-O__xyQXE"};